// Store
import store from '@/app/stores/store.js';

// Constants
import {TOKEN_ERR, ERROR_MSG} from '@/app/constants/constants.js';

// Import vue
import Vue from 'vue';

export const apiInterceptor = (instance) => {
	// Interceptors
	instance.interceptors.request.use(config => {
		let userToken = store.getters.getUserToken;
		if (userToken) {
			config.headers['Authorization'] = `Bearer ${userToken}`;
		}
		return config;
	}, function (error) {
		return Promise.reject(error);
	});

	instance.interceptors.response.use(response =>  {
		// Redirect to login if token has expired
		if (response.data.errors) {
			const hasTokenError = response.data.errors.some(e => {
				return e.message === TOKEN_ERR.EXPIRED || e.message === TOKEN_ERR.INVALID;
			});
	
			if (hasTokenError) {
				store.dispatch('logout');
			}

			const hasUserInactiveError = response.data.errors.some(e => {
				return e.message === ERROR_MSG.INACTIVE_USER;
			});

			if (hasUserInactiveError) {
				store.dispatch('logout');
				store.commit('setAuthMessage', {status: 'failed', message: ERROR_MSG.INACTIVE_USER});
			}
		}

		return response;
	}, function (error) {
		// Show timeout error
		if (error.message === ERROR_MSG.TIMEOUT_EXCEEDED) {
			Vue.notify({
				group: 'notifs',
				type: 'error',
				title: ERROR_MSG.INTERNAL_ERROR_TITLE,
				text: ERROR_MSG.INTERNAL_CONNECTION_TIMEOUT,
				duration: -1,
				closeOnClick: true
			});
		}

		return Promise.reject(error);
	});
}